export default "__VITE_ASSET__mozXkLzu__"